export default "__VITE_ASSET__oKfO_$m1__"